import { render, staticRenderFns } from "./PowerMeasurement.vue?vue&type=template&id=5c08d053"
import script from "./PowerMeasurement.vue?vue&type=script&lang=js"
export * from "./PowerMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports